import { render, staticRenderFns } from "./merchant-account-summary-card.vue?vue&type=template&id=d8213c80&scoped=true&lang=pug"
import script from "./merchant-account-summary-card.vue?vue&type=script&lang=ts"
export * from "./merchant-account-summary-card.vue?vue&type=script&lang=ts"
import style0 from "./merchant-account-summary-card.vue?vue&type=style&index=0&id=d8213c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8213c80",
  null
  
)

export default component.exports